import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, of, switchMap } from 'rxjs';
import { isPublicImageUrl } from 'src/app/core/helpers/public-image-url.helper';

@Pipe({
  name: 'secureBlob',
  standalone: true,
  pure: true
})
export class SecureBlobPipe implements PipeTransform {
  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  transform(blobUrl: string | null | undefined): Observable<SafeUrl> | null {
    if (!blobUrl) {
      return null;
    }

    // Pass through local data URLs and object URLs without fetching
    if (blobUrl.startsWith('data:') || blobUrl.startsWith('blob:') || isPublicImageUrl(blobUrl)) {
      return of(this.sanitizer.bypassSecurityTrustUrl(blobUrl));
    }

    // The backend already converts raw blob URLs to proxy URLs via BlobProxyHelper.
    // Call the URL directly — the MSAL auth interceptor attaches the Bearer token.
    return this.http.get(blobUrl, { responseType: 'blob' }).pipe(
      switchMap(blob => new Observable<SafeUrl>(observer => {
        const reader = new FileReader();
        reader.onloadend = () => {
          observer.next(this.sanitizer.bypassSecurityTrustUrl(reader.result as string));
          observer.complete();
        };
        reader.onerror = err => observer.error(err);
        reader.readAsDataURL(blob);
      }))
    );
  }
}
